module.exports = __webpack_public_path__ + "1648d3145488f4edaa7fd705439966ef.svg";